import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { getAuditLogs } from "../../utils/network/Crud";
import { AUDIT_FIELD_LABELS } from "../../utils/helper";
import { SUPER_ADMIN_EMAIL } from "../../Auth";
import useTheme from "../../utils/useTheme";
import BackButton from "../../Components/BackButton";
import Loader from "../../Components/ProgressBar/Loader";
import styles from "./AllDonations.module.scss";
import { MdOutlineHistory } from "react-icons/md";

const ActivityLog = () => {
  const { userData } = useTheme();
  const navigate = useNavigate();
  const [allLogs, setAllLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const isExpense = type === "expense";
  const logs =
    type === "expense" || type === "donation"
      ? allLogs.filter((log) =>
          isExpense
            ? log.collectionName === "expense"
            : log.collectionName !== "expense"
        )
      : allLogs;

  useEffect(() => {
    if (userData?.email !== SUPER_ADMIN_EMAIL) {
      navigate("/");
      return;
    }
    const fetchLogs = async () => {
      setLoading(true);
      const result = await getAuditLogs();
      setAllLogs(result?.data || []);
      setLoading(false);
    };
    fetchLogs();
  }, [userData, navigate]);

  if (userData?.email !== SUPER_ADMIN_EMAIL) return null;
  if (loading) return <Loader />;

  return (
    <>
      <BackButton
        title={
          type === "expense"
            ? "Expense Update Activity"
            : type === "donation"
            ? "Donation Update Activity"
            : "Update Activity"
        }
      />
      <div className={styles.container}>
        <div className={styles.statsGrid}>
          <div className={styles.statCard}>
            <div className={styles.statIcon}>
              <MdOutlineHistory />
            </div>
            <div>
              <h3>{logs.length}</h3>
              <p>Total Updates</p>
            </div>
          </div>
        </div>

        <div className={styles.panel}>
          {logs.length ? (
            <ul className={styles.listContainer}>
              {logs.map((log) => (
                <li key={log.id} className={styles.listItem}>
                  <div className={styles.cardContent}>
                    <div className={styles.name}>
                      {log.entryLabel || "Untitled"}{" "}
                      <span style={{ color: "#8b81a3", fontWeight: 500 }}>
                        (
                        {log.collectionName === "expense"
                          ? "Expense"
                          : "Donation"}
                        )
                      </span>{" "}
                      {log.action === "deleted" && (
                        <span
                          style={{
                            color: "#ff6b6b",
                            fontWeight: 600,
                            fontSize: 11,
                            border: "1px solid #ff6b6b",
                            borderRadius: 4,
                            padding: "1px 6px",
                          }}
                        >
                          Deleted
                        </span>
                      )}
                    </div>
                    <span className={styles.address}>
                      <b>Updated by</b> :{" "}
                      {log.changedByName || log.changedByEmail || "Unknown"}
                    </span>
                    <span className={styles.address}>
                      <b>Date</b> :{" "}
                      {log.date?.seconds
                        ? moment
                            .unix(log.date.seconds)
                            .format("DD-MM-YYYY hh:mm A")
                        : ""}
                    </span>
                    <div style={{ marginTop: 8 }}>
                      {Object.entries(log.changes || {}).map(
                        ([field, change]) => (
                          <div
                            key={field}
                            style={{
                              fontSize: 12,
                              color: "#c9c0dc",
                              marginBottom: 4,
                            }}
                          >
                            <b style={{ color: "#f0b23c" }}>
                              {AUDIT_FIELD_LABELS[field] || field}
                            </b>
                            : {String(change.old) || "—"} →{" "}
                            {String(change.new) || "—"}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className={styles.emptyList}>No updates recorded yet.</div>
          )}
        </div>
      </div>
    </>
  );
};

export default ActivityLog;
